module.exports = __webpack_public_path__ + "static/img/date.43878da9.svg";